import {
    fontFamilyBrandonMedium,
    fontFamilyBrandonRegular,
    fontFamilyChronicleLight,
    fontFamilyChronicleRoman,
} from '../Fonts';

export default {
    fontBrandonMedium: `'${fontFamilyBrandonMedium}', 'Gill Sans', 'Arial', sans-serif`,
    fontBrandonRegular: `'${fontFamilyBrandonRegular}', 'Gill Sans', 'Arial', sans-serif`,
    fontChronicleLight: `'${fontFamilyChronicleLight}', 'Times New Roman', serif`,
    fontChronicleRoman: `'${fontFamilyChronicleRoman}', 'Times New Roman', serif`,
};
